import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import { alpha, styled } from "@mui/material/styles"

import Row from "../../../common/components/Row"

export default function DialogHeader({
  title,
  onClose,
  showCloseButton = true,
  actions,
  closeButtonTitle,
}) {
  return (
    <DialogHeaderContainer sx={title ? {} : { p: 0 }}>
      <Typography variant="h3">{title}</Typography>
      <Row sx={{ alignItems: "center", gap: 1, ml: "auto" }}>
        {actions}
        {showCloseButton && (
          <CloseIconButton
            onClick={() => onClose()}
            title={closeButtonTitle}
            aria-label={closeButtonTitle || "Close"}
          >
            <CloseOutlinedIcon />
          </CloseIconButton>
        )}
      </Row>
    </DialogHeaderContainer>
  )
}

const DialogHeaderContainer = styled(Row)(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  paddingInline: theme.spacing(3),
  paddingBlock: theme.spacing(2),
  backgroundColor: theme.palette.colors.gray50,
  borderBottom: `1px solid ${theme.palette.colors.gray200}`,
  [theme.breakpoints.only("xs")]: {
    paddingInline: theme.spacing(2),
    justifyContent: "center",
    position: "relative",
    backgroundColor: "inherit",
    borderBottom: "none",
    borderTopLeftRadius: theme.spacing(3),
    borderTopRightRadius: theme.spacing(3),
  },
}))

const CloseIconButton = styled(IconButton)(({ theme }) => ({
  [theme.breakpoints.only("xs")]: {
    position: "absolute",
    left: "calc(50% - 22px)",
    top: "-52px",
    backgroundColor: alpha(theme.palette.colors.gray900, 0.8),
    "& .MuiSvgIcon-root": {
      color: "white",
    },
    width: "44px",
    height: "44px",
  },
}))
